import React from "react";
import { observer } from "mobx-react-lite";

import { Box, Label, Show } from "Components";
import ScheduleChart from "./ScheduleChart/ScheduleChart";
import { WeeklyRotaDetailsViewModel } from "./WeeklyRotaDetailViewModel";
import MentorAbsenceView from "./MentorAbsence/MentorAbsenceView";
import ResetRotaConfirmationPopup from "./ResetRotaConfirmationPopup";
import SessionLeftModal from "../Modal/SessionLeftModal";
import { AddAbsenceButton, ResetRotaButton, SwitchBox, SwitchTitleBox, TableBox } from "./WeeklyRotaDetailView.styles";

export interface WeeklyRotaDetailViewProps {
    viewModel: WeeklyRotaDetailsViewModel;
}

export const WeeklyRotaDetailView: React.FC<WeeklyRotaDetailViewProps> = observer(({ viewModel }) => {
    return (
        <>
            <Show if={viewModel.hasNoWeeklyRota}>
                <Box flexBox width={"100%"}>
                    <Label fontStyle="p">No rota has been created for this week</Label>
                </Box>
            </Show>
            <Show if={viewModel.hasWeeklyRota}>
                <RotaToolbar viewModel={viewModel} />
                <RotaScheduleTable viewModel={viewModel} />
                <RotaModals viewModel={viewModel} />
            </Show>
        </>
    );
});

// ─── Composer sub-components ─────────────────────────────────────────────────

interface RotaToolbarProps {
    viewModel: WeeklyRotaDetailsViewModel;
}

const RotaToolbar: React.FC<RotaToolbarProps> = observer(({ viewModel }) => (
    <SwitchTitleBox>
        <Show if={viewModel.rotaEditable}>
            <ResetRotaButton command={viewModel.showResetRotaConfirmationCommand} displayName={"Reset rota"} paletteColor="primary" />
        </Show>
        <AddAbsenceButton command={viewModel.showMentorAbsenceModalCommand} displayName={"ADD MENTOR ABSENCE"} paletteColor="primary" />
        <LiveEditableToggle viewModel={viewModel} />
    </SwitchTitleBox>
));

interface RotaScheduleTableProps {
    viewModel: WeeklyRotaDetailsViewModel;
}

const RotaScheduleTable: React.FC<RotaScheduleTableProps> = observer(({ viewModel }) => (
    <TableBox>
        <ScheduleChart viewModel={viewModel} />
    </TableBox>
));

interface RotaModalsProps {
    viewModel: WeeklyRotaDetailsViewModel;
}

const RotaModals: React.FC<RotaModalsProps> = observer(({ viewModel }) => (
    <>
        <Show if={viewModel.resetRotaConfirmationOpen}>
            <ResetRotaConfirmationPopup closeCommand={viewModel.closeResetRotaConfirmationCommand} confirmCommand={viewModel.resetRotaCommand} />
        </Show>
        <Show if={viewModel.mentorAbsenceModalOpen}>
            <MentorAbsenceView viewModel={viewModel} cancelCommand={viewModel.showMentorAbsenceModalCommand} />
        </Show>
        <Show if={viewModel.sessionLeftModalOpen}>
            <SessionLeftModal viewModel={viewModel} closeCommand={viewModel.showSessionLeftModalCommand} />
        </Show>
    </>
));

interface LiveEditableToggleProps {
    viewModel: WeeklyRotaDetailsViewModel;
}

const LiveEditableToggle: React.FC<LiveEditableToggleProps> = observer(({ viewModel }) => (
    <SwitchBox>
        <Label fontStyle="h2">Live</Label>
        <label className="switch">
            <input type="checkbox" onClick={viewModel.showEditableScheduleCommand.execute} />
            <span className="slider round"></span>
        </label>
        <Label fontStyle="h2">Editable</Label>
    </SwitchBox>
));
